import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";
import { GROUND_TOTAL, Grounding } from "@/components/landing/Grounding";
import { ToolFinish } from "@/components/tools/ToolFinish";
import { resetTrack, track } from "@/lib/toolTrack";

export const GroundTool = ({ tool }) => {
  const [stage, setStage] = useState("ready");
  const [taps, setTaps] = useState(0);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const begin = () => { resetTrack(tool.slug); setTaps(0); setStage("run"); track(tool.slug, "start"); };
  const tap = () => {
    const n = taps + 1;
    setTaps(n);
    if (n >= GROUND_TOTAL) timer.current = setTimeout(() => { setStage("done"); track(tool.slug, "finish"); }, 1200);
  };
  if (stage === "done") return <ToolFinish tool={tool} onAgain={begin} />;
  if (stage === "ready") return (
    <div className="text-center" data-testid="tool-ground-ready">
      <p className="text-mm-muted mb-5">Look around you. You'll name 5 things you see, 4 you can touch, 3 you hear, 2 you smell and 1 you taste.</p>
      <button onClick={begin} className="mm-btn !px-8 !py-3.5 text-lg" data-testid="tool-start"><Play size={18} />Start</button>
    </div>
  );
  return (
    <div>
      <Grounding taps={taps} onTap={tap} />
      <div className="text-center mt-4"><button onClick={() => { clearTimeout(timer.current); setStage("ready"); }} className="text-sm text-mm-muted underline" data-testid="tool-stop">Stop</button></div>
    </div>
  );
};
